import React, { FC, ReactNode, useCallback, useMemo } from 'react'
import { Box, Button, Flex, ListIcon, ListItem, Text } from '@chakra-ui/react'
import { Check } from 'react-feather'
import { useNavigate } from 'react-router-dom'
import useGa from 'hooks/ga/useGa'
import { getIconStyles, styleCard, styleStepper } from './styled'

interface IPath {
  pathName: string;
  options?: unknown;
}

interface IBStepProps {
  index: number;
  title: string;
  filledTitle: string;
  path: IPath;
  isSent: boolean
  description: string;
  textButton: string;
  status: string;
  children: ReactNode;
  [x: string]: unknown;
}

const IBStep: FC<IBStepProps> = ({ index, title, filledTitle, path, isSent, description, textButton, status, children, ...rest }) => {
  const navigate = useNavigate()
  const isFilled = status === 'FILLED'
  const isNull = status === 'BLOCKED'
  const isEmpty = status === 'EMPTY'
  const navigateOptions = path.options || {}
  const { sendDataLayer } = useGa()

  const isLoadCompanyData = useMemo( () => isFilled || isSent,  [isFilled, isSent] )
  const filledText = useMemo( () => isFilled ? 'Ver o modificar' : 'Ver detalle',  [isFilled] )
  const loadCompanyTitle = useMemo( () => isLoadCompanyData ? filledTitle : title, [isLoadCompanyData, filledTitle, title] )
 

  const handleNavigate = (pathName: string, text: string) => {
    navigate(pathName, navigateOptions)
    sendDataLayer({
      event: 'select_content',
      content_group: 'Onboarding',
      content_type: 'CTAs pantalla de tareas',
      item_id: text
    })
  }

  const onClickHandleNavigate = useCallback(() => {handleNavigate(path.pathName, textButton)}, [path, textButton])
  const onClickHandleNavigateFilled = useCallback(() => {handleNavigate(path.pathName, filledText)}, [path, isFilled])

  return (
    <ListItem {...rest}>
      <Flex {...styleStepper(index, status)} pos='relative'>
        {
          isLoadCompanyData ? <ListIcon as={Check} {...getIconStyles(status)} fontSize='22px' m={3} mr={10} /> :
            <Text color={getIconStyles(status)?.color} textStyle='h5Bold' m={4} mr={10}>{index}</Text>
        }
        <Flex {...styleCard(status)}>
          <Box flex={1}>
            <Text textStyle='h4Bold' color={isNull ? 'neutral.90' : ''} paddingRight='70px'>{loadCompanyTitle}</Text>
          </Box>
          <Box flex={4} alignItems='left'>
            {isLoadCompanyData ? children : <Text textStyle='bodyMdSemi' color={status !== 'BLOCKED' ? 'grey.120' : 'neutral.90'}>{description}</Text>}
          </Box>
          <Box flex={1}>
            {isNull || isEmpty ?
              <Button borderRadius='10px' onClick={onClickHandleNavigate} w='200px' ml='80px' disabled={isNull} border='solid 1px' data-testid={`button-action-${index}`}>
                {textButton}
              </Button> :
              <Button onClick={onClickHandleNavigateFilled} variant='primary-text' w='200px' ml='80px' disabled={isNull} data-testid={`button-action-${index}`}>
                {filledText}
              </Button>
            }
          </Box>
        </Flex>
      </Flex>
    </ListItem>
  )
}


export default IBStep